export const getHubUrl = (locale: string, slug?: string) => {
  return `${process.env.NX_HUB_BASE_URL}/${locale}/hub/${slug || ""}`;
};

export const getProFeaturesUrl = (locale: string, slug?: string) => {
  return `${process.env.NX_HUB_BASE_URL}/${locale}/pro-features/${slug || ""}`;
};

export const getSignUpUrl = (locale: string) => {
  switch (locale) {
    case "en-gb":
      return `https://join.${process.env.NX_UENI_DOMAIN}/gb/website-launch/`;
    case "en-us":
      return `https://join.${process.env.NX_UENI_DOMAIN}/us/website-launch/`;
    case "en-ca":
      return `https://join.${process.env.NX_UENI_DOMAIN}/ca/website-launch/`;
    case "en-in":
      return `https://join.${process.env.NX_UENI_DOMAIN}/in/lifetime/`;
    case "es-es":
      return `https://join.${process.env.NX_UENI_DOMAIN}/es/lifetime`;
    case "es-mx":
      return `https://webgratis.${process.env.NX_UENI_DOMAIN}/mx/pago-unico/?redirect=false`;
    case "pt-br":
      return `https://webgratis.${process.env.NX_UENI_DOMAIN}/br/plano-vitalicio/?redirect=false`;
    default:
      return `${process.env.NX_HUB_BASE_URL}/${locale}?search=true`;
  }
};

export const getHomePageUrl = (locale: string) => `${process.env.NX_HUB_BASE_URL}/${locale}`;
